// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 1400px) {\n.sub-menu\n    .m-menu__nav\n    .m-menu__item.m-menu__item--active\n    .m-menu__link\n    .m-menu__item-here {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
